export default class AccountRegistrationSurveyForm {
    constructor(source, moreInformation) {
        this.source = source;
        this.moreInformation = moreInformation;
    }
}
